import React from 'react'

// libraries
import { Turnstile } from '@marsidev/react-turnstile'
import Typography from '@mui/material/Typography'

// shared components
import RegistrationStep from 'components/register/shared/RegistrationStep'
import Loading from 'components/atoms/Loading'

// local components
import AccountCreated from './AccountCreated'

// local containers
import Form from './Form'

const NewAccount = props => {
  const {
    queryLoading,
    mutationLoading,
    form,
    account,
    setToken,
    appSettings
  } = props

  const { enableCaptcha, turnstileSiteKey } = appSettings

  // Conditionally, create a Turnstile component to pass as a prop
  const turnstileComponent = enableCaptcha ? (
    <Turnstile
      siteKey={turnstileSiteKey}
      onSuccess={setToken}
      options={{ theme: 'light' }}
    />
  ) : null

  return (
    <>
      <RegistrationStep>
        <Typography mb={4} variant='h2' align='center'>
          Parent / Guardian
        </Typography>

        {queryLoading || !form ? (
          <Loading />
        ) : account ? (
          <AccountCreated {...props} />
        ) : (
          <>
            <Typography pb={1} variant='body1' align='center'>
              Enter the details of the Parent/Guardian who will be the main
              contact for this account.
            </Typography>
            <Typography pb={4} variant='body1' align='center'>
              This person will also be the primary emergency contact.
            </Typography>

            <Form
              buttonText={mutationLoading ? 'Saving…' : 'Save and Continue'}
              turnstileComponent={turnstileComponent}
              {...props}
            />
          </>
        )}
      </RegistrationStep>
    </>
  )
}

export default NewAccount
